import { motion } from 'framer-motion';
import { Code, Smartphone, Globe, TrendingUp, Palette, Camera, Film, Users, Sparkles, Video, Book, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
 const appdroidServices = [
  { icon: <Code />, title: 'Custom Software Development', desc: 'Enterprise-grade software built to your exact requirements — scalable, secure, and future-proof.' },
  { icon: <Smartphone />, title: 'Mobile App Development', desc: 'High-performance iOS and Android apps designed for real users and real business outcomes.' },
  { icon: <Globe />, title: 'Web Development', desc: 'Fast, modern websites and web apps that look great and convert visitors into customers.' },
  { icon: <TrendingUp />, title: 'Digital Marketing', desc: 'Data-driven campaigns across SEO, paid media, and social — built to grow your revenue.' },
  { icon: <Palette />, title: 'UI/UX Design', desc: 'Intuitive, beautiful interfaces that reduce friction and keep users coming back.' },
];

  const fusionScopeServices = [
    {
      icon: <Camera />,
      title: 'AI Product Shoots',
      desc: 'Hyperrealistic product visuals with perfect lighting and brand mood.',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FScreenshot%202026-04-11%20at%207.31.11%E2%80%AFPM.png?alt=media&token=278e1737-aca7-4253-ba6c-cf084c913761',
    },
    {
      icon: <Sparkles />,
      title: 'AI Jewellery Shoots',
      desc: 'Ultra-detailed diamond and gold renders with true-to-design replication.',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Ffreepik__enhance__88631.jpeg?alt=media&token=1f831937-e104-48d7-b092-5de65bef463d',
    },
    {
      icon: <Users />,
      title: 'AI Model & Fashion Shoots',
      desc: 'Editorial-quality portraits and lookbooks with Indian model references.',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Freplicate_this_exact_202604121121.png?alt=media&token=97131a46-55f8-44b2-bf40-94ecd21af9de',
    },
    {
      icon: <Film />,
      title: 'AI Cinematic Videos',
      desc: 'Brand films & TVCs with end-to-end AI-driven storytelling.',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Fcinematic.webp?alt=media&token=53c24fb0-d72d-4ee8-9511-60e5492ab17a',
    },
    {
      icon: <Users />,
      title: 'AI Promotional Videos',
      desc: 'Studio quality, engaging visuals and concept for performance driven campaigns.',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Fpromotional.png?alt=media&token=6384eb4b-6224-4ba3-a3d8-5c4ce4ea8071',
    },
    {
      icon: <Video />,
      title: 'UGC & Social Media Content',
      desc: 'Scroll-stopping reels and ultra-realistic social content.',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FUGC.png?alt=media&token=ddef5d5b-bae2-4477-a3ff-a39b6730128e',
    },
    {
      icon: <Film />,
      title: 'AI Video Songs',
      desc: 'Animated and ultra-realistic music video production.',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FGata_rahe.webp?alt=media&token=52d2fa4b-0e73-4cb9-ac7a-8276d1934fae',
    },
    {
      icon: <Heart />,
      title: 'Devotional & Mythological Content',
      desc: 'Animated and ultra-realistic devotional videos.',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FIndra.webp?alt=media&token=645dd2e3-3ae0-4794-9806-a3cc4af30110',
    },
    {
      icon: <Book />,
      title: 'Educational AI Content',
      desc: 'Engaging educational content with AI visualization.',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Feducation.webp?alt=media&token=c06ba314-686a-48d0-a785-46180f886d96',
    },
    {
      icon: <Users />,
      title: 'Real Character Regeneration',
      desc: 'Regenerate real characters for cinematic visuals, monologues, and dialogues.',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Fgulzar.webp?alt=media&token=fc7c8779-fa37-44f4-ba92-41b7cf69ed89',
    },
  ];

  return (
    <div data-testid="services-page" className="min-h-screen">
      {/* Hero with Video Background */}
      <section className="min-h-screen flex items-center justify-center relative overflow-hidden">
        {/* Video Background */}
        <div className="absolute inset-0 w-full h-full">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
            style={{ filter: 'brightness(0.6)' }}
          >
            <source
              src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4"
              type="video/mp4"
            />
          </video>
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
          <div
            className="absolute inset-0 opacity-30"
            style={{
              background:
                'radial-gradient(circle at 50% 50%, rgba(124, 58, 237, 0.2) 0%, rgba(10, 10, 10, 0) 70%)',
            }}
          />
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-6xl md:text-8xl font-black tracking-tighter leading-none uppercase mb-6 text-white drop-shadow-2xl">
              Our Services
            </h1>
            <p className="text-xl md:text-2xl text-white/80 max-w-2xl drop-shadow-lg">
              From software that powers your business to AI content that grows your brand — all under one roof.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Vertical 1: Appdroid Tech */}
      <section className="py-24 md:py-32 bg-card">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-16"
          >
            <div className="flex items-center gap-4 mb-6">
              <span className="text-xs font-bold tracking-[0.2em] uppercase text-purple-500">01</span>
              <div className="h-px bg-purple-500/30 flex-1" />
            </div>
            <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight leading-tight mb-4">
              Technology & Software
            </h2>
            <p className="text-lg text-muted">Scalable digital products built for real-world performance</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {appdroidServices.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.02 }}
                className="bg-card border border-themed rounded-2xl p-8 hover:border-purple-500/50 transition-all duration-500 group"
              >
                <div className="text-purple-500 mb-4 group-hover:scale-110 transition-transform">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold mb-3">{service.title}</h3>
                <p className="text-sm text-muted leading-relaxed">{service.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="h-px bg-gradient-to-r from-transparent via-purple-500 to-transparent" />
      </div>

      {/* Vertical 2: Fusion Scope */}
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-16"
          >
            <div className="flex items-center gap-4 mb-6">
              <span className="text-xs font-bold tracking-[0.2em] uppercase text-purple-500">02</span>
              <div className="h-px bg-purple-500/30 flex-1" />
            </div>
            <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight leading-tight mb-4">
              AI Content Studio
            </h2>
            <p className="text-lg text-muted">Cinematic AI content that makes your brand impossible to ignore</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {fusionScopeServices.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.02 }}
                className="bg-card border border-themed rounded-2xl overflow-hidden hover:border-purple-500/50 transition-all duration-500 group"
              >
                <div className="aspect-video relative overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                  <div className="absolute bottom-4 left-4 text-purple-500">{service.icon}</div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">{service.title}</h3>
                  <p className="text-sm text-muted leading-relaxed">{service.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-24 md:py-32 bg-card">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight leading-tight mb-8">
              Have a project in mind?
              <br />
              <span className="text-purple-500">Let's build it.</span>
            </h2>
            <Link to="/contact"
              data-testid="services-contact-btn"
              className="bg-purple-600 hover:bg-purple-700 text-white px-10 py-5 rounded-full font-bold text-lg tracking-wide transition-all hover:scale-105 hover:shadow-[0_0_30px_rgba(124,58,237,0.6)] inline-block"
            >
              Get Started
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;